import { useEffect, useState, useMemo, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { message, Modal, Radio, Input, Table, Tag, Button } from 'antd';
import { Loading } from '../../base-components/loading';
import { getReportsByRiskFlag, getLevelList, getRiskFlag, updateLevel } from '../../service/report';
import './style.scss';

const baseColumns = [
    {
        title: '受理号',
        dataIndex: 'flowId',
        key: 'flowId',
        align: 'center',
        width: 150
    },
    {
        title: '骑手',
        dataIndex: 'rider',
        key: 'rider',
        align: 'center',
        width: 150
    },
    {
        title: '报案人',
        dataIndex: 'reporter',
        key: 'reporter',
        align: 'center',
        width: 150
    },
    {
        title: '出险时间',
        dataIndex: 'accidentTime',
        key: 'accidentTime',
        align: 'center',
        width: 150
    },
    {
        title: '报案时间',
        dataIndex: 'reportTime',
        key: 'reportTime',
        align: 'center',
        width: 150
    },
    {
        title: '处理人',
        dataIndex: ['handler', 'fullName'],
        key: 'handler.fullName',
        align: 'center',
        width: 150
    },
    {
        title: '状态',
        dataIndex: 'state',
        key: 'state',
        align: 'center',
        width: 150
    },
    {
        title: '出险地址',
        dataIndex: 'accidentAddr',
        key: 'accidentAddr',
        align: 'center',
        width: 150
    },
    {
        title: '出险经过',
        dataIndex: 'accidentDetail',
        key: 'accidentDetail',
        align: 'center',
        width: 150
    }
];

function RiskFlag(props) {
    const [flagResult, setFlagResult] = useState({});
    const [isFinish, setIsFinish] = useState(false);
    const [reason, setReason] = useState('');
    const [levels, setLevels] = useState([]);
    const [levelVisible, setLevelVisible] = useState(false);
    const [levelId, setLevelId] = useState();
    const [reportList, setReportList] = useState([]);
    const [reportVisible, setReportVisible] = useState(false);
    const flowId = useMemo(() => props.flowId, [props.flowId]);
    const agentId = useMemo(() => props.agentId, [props.agentId])
    const canEdit = useMemo(() => props.canEdit, [props.canEdit]);

    const tenant = useMemo(() => props.tenant, [props.tenant]);

    const colunms = useMemo(() => {
        function viewReport (detail) {
            const { actions, agentId } = props;
            setReportVisible(false);
            Loading.show();
            if (
                agentId !== (detail.handler && detail.handler._id)
            ) {
                const flowId = detail.flowId;
                // 获取案件信息
                if (!flowId) {
                    return;
                }
                props.history.push(`/customerCenter/ReportDetail/${flowId}`);
            } else {
                actions.getCreateReport('update');
                actions.changeActiveReportTab('1');
                actions.getCurrentReport(detail.flowId);
                setTimeout(() => {
                    props.history.push({
                        pathname: `/workBench/ReportDetail/${detail.flowId}`,
                        query: {}
                    })
                }, 300);
            }
            Loading.hide();
            props.viewReport && props.viewReport(item);
        }
        return [
            ...baseColumns,
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                align: 'center',
                render: (text, record) => (
                    <Button type="link" onClick={() => viewReport(record)}>
                        查看
                    </Button>
                )
            }
        ];
    }, [baseColumns, props]);

    const handleViewReportsByFlag = useCallback(
        (item) => {
            if (item.riskType !== 'LOSS_TIMES') {
                return;
            }
            if (!props.flowId) {
                return;
            }
            Loading.show();
            getReportsByRiskFlag({
                flowId: props.flowId,
                agentId: props.agentId,
                riskFlagId: item._id
            })
                .then((data) => {
                    Loading.hide();
                    setReportList(data.result);
                    setReportVisible(true);
                })
                .catch((err) => {
                    Loading.hide();
                    message.error(err.message || '请求/api/riskContr/flag/aboutReports失败');
                });
        },
        [props.flowId, props.agentId]
    );
    const getFlag = useCallback(() => {
        if (!props.flowId) {
            return;
        }
        getRiskFlag({
            flowId: props.flowId,
            agentId: props.agentId
        }).then((data) => {
            const flagResult = data.result;
            setFlagResult(flagResult);
            setIsFinish(true);
            setLevelId(
                Object.keys(flagResult).length
                    ? flagResult.isManual
                        ? flagResult?.manualRiskLevel?.levelId
                        : flagResult?.highestAutoRiskLevel?.levelId
                    : undefined
            );
        });
    }, [props.flowId, props.agentId]);

    const handleCancel = useCallback(() => {
        setReason();
        setLevelVisible(false);
        setLevelId(
            Object.keys(flagResult).length
                ? flagResult.isManual
                    ? flagResult?.manualRiskLevel?.levelId
                    : flagResult?.highestAutoRiskLevel?.levelId
                : undefined
        );
    }, [flagResult]);

    const handleUpdateLevel = useCallback(
        (e) => {
            if (!props.flowId) {
                return;
            }
            if (!levelId) {
                message.error('请先选择风险等级');
                return;
            }
            if (!reason) {
                message.error('请输入自定义原因');
                return;
            }
            updateLevel({
                flowId: props.flowId,
                agentId: props.agentId,
                riskLevelId: levelId,
                reason: reason
            })
                .then(() => {
                    message.success('操作成功');
                    getFlag();
                    setReason();
                    setLevelVisible(false);
                })
                .catch(() => {});
        },
        [props.flowId, props.agentId, levelId, reason]
    );

    useEffect(() => {
        if (!flowId || !agentId) {
            return;
        }
        console.log('useEffect', flowId)
        getFlag();
        getLevelList({
            agentId: agentId
        })
            .then(({ result }) => {
                setLevels(result);
            })
            .catch((err) => {});
    }, [flowId, agentId]);

    return (
        <React.Fragment>
            <div className="report-risk">
                {Object.keys(flagResult).length !== 0 ? (
                    <span
                        style={{
                            color: flagResult.isManual
                                ? flagResult?.manualRiskLevel?.bgColor
                                : flagResult?.highestAutoRiskLevel?.bgColor,
                            marginRight: 10,
                            marginBottom: 4,
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {flagResult?.isManual ? '手动' : '自动'}：
                        {flagResult?.isManual
                            ? flagResult?.manualRiskLevel?.levelName
                            : flagResult?.highestAutoRiskLevel?.levelName}
                        {
                            tenant?.riskContrMod?.riskMarks && tenant.riskContrMod.riskMarks.includes('MANUAL') ? (
                                <i
                                    className="iconfont icon-edit"
                                    onClick={() => setLevelVisible(true)}
                                />
                            ) : null
                        }
                    </span>
                ) : isFinish && tenant?.riskContrMod?.riskMarks.length ? (
                    <span style={{ color: '#000' }}>
                        未检测到风险点
                        {tenant?.riskContrMod?.riskMarks &&
                        tenant.riskContrMod.riskMarks.includes('MANUAL') ? (
                            <i
                                className="iconfont icon-edit-fill"
                                onClick={() => setLevelVisible(true)}
                            />
                        ) : null}
                    </span>
                ) : null}
                <p>
                    {flagResult?.flags
                        ? flagResult.flags.map((item, index) => (
                            <Tag
                                onClick={() => handleViewReportsByFlag(item, index)}
                                color={item.bgColor}
                                key={item._id}
                            >
                                {item.desc}
                                {item.riskType === 'LOSS_TIMES' ? (
                                    <i
                                        className="iconfont icon-search"
                                        style={{ marginLeft: 2, verticalAlign: 'middle' }}
                                    />
                                ) : null}
                            </Tag>
                        ))
                        : null}
                    {flagResult?.reason ? (
                        <Tag
                            color={
                                flagResult?.isManual
                                    ? flagResult?.manualRiskLevel?.bgColor
                                    : flagResult?.highestAutoRiskLevel?.bgColor
                            }
                        >
                            {flagResult?.reason}
                        </Tag>
                    ) : null}
                </p>
            </div>
            
            <Modal
                title="修改等级"
                visible={levelVisible}
                onOk={handleUpdateLevel}
                onCancel={handleCancel}
            >
                {
                    <Radio.Group onChange={(e) => setLevelId(e.target.value)} value={levelId}>
                        {levels.map((item) => (
                            <Radio key={item.levelId} value={item.levelId}>
                                {item.levelName}
                            </Radio>
                        ))}
                    </Radio.Group>
                }

                <div style={{ height: 20 }}></div>
                <Input.TextArea
                    placeholder="请输入原因"
                    onChange={(e) => setReason(e.target.value)}
                    value={reason}
                    rows={4}
                />
            </Modal>
            <Modal
                title=""
                visible={reportVisible}
                onOk={() => setReportVisible(false)}
                onCancel={() => setReportVisible(false)}
                width="90%"
                closable={false}
            >
                <Table
                    rowKey="flowId"
                    scroll={{ y: 340 }}
                    pagination={false}
                    dataSource={reportList}
                    columns={colunms}
                />
            </Modal>
        </React.Fragment>
    );
}

export default withRouter(RiskFlag)